import type {
  Carrier,
  CarrierMultipleAggregate,
  CarrierState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/carriers';

export const get = (state: CarrierState, id: number): Carrier | undefined => state.byId[id];
export const all = (state: CarrierState): Record<number, Carrier> => state.byId;
export const getMultiple = (state: CarrierState): CarrierMultipleAggregate | null => state.multiple;
export const getCurrentResultIds = (state: CarrierState): number[] => state.currentResultIds;
